/* HALO Header: estado ao rolar, fundo automático, painéis do computador e menu do celular. */
(function () {
  if (customElements.get('halo-header')) return;

  var DESKTOP = window.matchMedia('(min-width: 992px)');

  function parseColor(value) {
    var m = value && value.match(/rgba?\(([^)]+)\)/);
    var scale = 1;
    if (!m) {
      m = value && value.match(/color\(srgb ([^)]+)\)/);
      scale = 255;
    }
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    return { r: p[0] * scale, g: p[1] * scale, b: p[2] * scale, a: p.length > 3 ? p[3] : 1 };
  }

  function luminance(c) {
    var ch = [c.r, c.g, c.b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
  }

  class HaloHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-halo-header-bar]');
      this.menu = this.querySelector('[data-hh-menu]');
      this.toggle = this.querySelector('[data-hh-toggle]');
      this.scrim = this.querySelector('[data-hh-scrim]');
      this.items = Array.from(this.querySelectorAll('[data-hh-item]'));
      this.auto = this.dataset.toneMode === 'auto';
      this.hideOnScroll = this.hasAttribute('data-hide-on-scroll');
      // Barra fixa de compra no estilo do menu: o arquivo dela é protegido e não muda; o
      // script só marca o tom e o formato no <html> (data-halo-barra) e o CSS faz o resto.
      this.atc = this.hasAttribute('data-barra-compra') ? document.querySelector('.sticky-atc[data-sticky-atc]') : null;
      this.openItem = null;
      this.mobileOpen = false;
      this.lastY = window.scrollY;
      this.lastTone = 0;
      this.ac = new AbortController();
      var signal = { signal: this.ac.signal };
      var passive = { passive: true, signal: this.ac.signal };

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, passive);
      window.addEventListener('resize', this.onScroll, passive);
      window.addEventListener('load', this.onScroll, signal);

      DESKTOP.addEventListener('change', this.onBreakpoint.bind(this), signal);
      this.onBreakpoint();

      if (this.toggle) {
        this.toggle.addEventListener('click', this.onToggle.bind(this), signal);
      }
      if (this.scrim) {
        this.scrim.addEventListener('click', this.closeAll.bind(this), signal);
      }

      this.items.forEach(function (item) {
        var trigger = item.querySelector('[data-hh-trigger]');
        item.addEventListener('pointerenter', this.onItemEnter.bind(this, item), signal);
        if (trigger) trigger.addEventListener('click', this.onTrigger.bind(this, item), signal);
      }, this);

      this.bar.addEventListener('pointerleave', this.onBarLeave.bind(this), signal);
      this.bar.addEventListener('pointerenter', this.cancelClose.bind(this), signal);
      this.bar.addEventListener('focusout', this.onFocusOut.bind(this), signal);
      this.bar.addEventListener('click', this.onBarClick.bind(this), signal);
      document.addEventListener('keydown', this.onKey.bind(this), signal);
      document.addEventListener('pointerdown', this.onOutside.bind(this), signal);
      document.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false, signal: this.ac.signal });
      document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this), signal);
      document.addEventListener('shopify:block:deselect', this.closeAll.bind(this), signal);

      this.watchBadge();
      this.onScroll();
    }

    disconnectedCallback() {
      this.ac.abort();
      delete document.documentElement.dataset.haloBarra;
      delete document.documentElement.dataset.haloBarraForma;
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (this.badgeObserver) this.badgeObserver.disconnect();
      if (this.panelObserver) this.panelObserver.disconnect();
      document.documentElement.classList.remove('halo-header-travado');
    }

    /* Rolagem: estado "rolado", esconder ao descer e fundo automático */
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update.bind(this));
    }

    update() {
      this.ticking = false;
      var y = Math.max(0, window.scrollY);
      this.classList.toggle('is-scrolled', y > 4);

      if (this.hideOnScroll && !this.isOpen()) {
        var delta = y - this.lastY;
        if (y < 120 || delta < -6) this.classList.remove('is-hidden');
        else if (delta > 6) this.classList.add('is-hidden');
      }
      this.lastY = y;

      if (this.auto || this.atc) {
        var now = Date.now();
        clearTimeout(this.toneTimer);
        if (now - this.lastTone > 90) {
          this.lastTone = now;
          this.detectTone();
        } else {
          this.toneTimer = setTimeout(this.detectTone.bind(this), 100);
        }
      }
    }

    detectTone() {
      if (this.atc) {
        // No fundo fixo (claro ou escuro), a barra de compra segue o menu.
        var atcTone = this.auto ? this.toneAt(window.innerHeight - 30, this.atc) : this.dataset.bg;
        if (document.documentElement.dataset.haloBarra !== atcTone) document.documentElement.dataset.haloBarra = atcTone;
      }
      if (!this.auto) return;
      var rect = this.bar.getBoundingClientRect();
      var y = Math.max(1, rect.top) + rect.height / 2;
      if (rect.bottom <= 0) y = rect.height / 2 + 8;
      var tone = this.toneAt(y, null);
      if (tone !== this.dataset.bg) {
        this.dataset.bg = tone;
        this.setLook();
      }
    }

    toneAt(y, skip) {
      // Percorre tudo o que está sob o ponto, de cima para baixo (inclui camadas de fundo
      // irmãs, como a do rodapé). Vale a primeira cor de fundo opaca; seções halo com fundo
      // em gradiente valem pela classe; data-halo-header-tone força o tom.
      var stack = document.elementsFromPoint(window.innerWidth / 2, y);
      var tone = null;
      for (var i = 0; i < stack.length && !tone; i++) {
        var el = stack[i];
        if (this.contains(el) || (skip && skip.contains(el)) || el === document.documentElement) continue;
        var forced = el.getAttribute('data-halo-header-tone');
        if (forced === 'claro' || forced === 'escuro') {
          tone = forced;
          break;
        }
        var cs = getComputedStyle(el);
        var c = parseColor(cs.backgroundColor);
        if (c && c.a >= 0.5) tone = luminance(c) > 0.4 ? 'claro' : 'escuro';
        else if (cs.backgroundImage !== 'none') {
          if (el.classList.contains('halo--dark')) tone = 'escuro';
          else if (el.classList.contains('halo--light') || el.classList.contains('halo--white')) tone = 'claro';
        }
      }
      if (!tone) {
        var body = parseColor(getComputedStyle(document.body).backgroundColor);
        tone = body && body.a >= 0.5 && luminance(body) <= 0.4 ? 'escuro' : 'claro';
      }
      return tone;
    }

    setLook() {
      this.dataset.look = this.isOpen() ? this.dataset.panel : this.dataset.bg;
    }

    isOpen() {
      return this.mobileOpen || !!this.openItem;
    }

    syncOpen() {
      var open = this.isOpen();
      this.classList.toggle('is-open', open);
      this.setLook();
      if (open) this.classList.remove('is-hidden');
    }

    onBreakpoint() {
      this.closeAll();
      this.classList.toggle('is-mobile', !DESKTOP.matches);
      if (this.atc) {
        var pill = this.classList.contains(DESKTOP.matches ? 'halo-header--d-pill' : 'halo-header--m-pill');
        document.documentElement.dataset.haloBarraForma = pill ? 'capsula' : 'barra';
      }
    }

    /* Computador: painéis */
    onItemEnter(item, e) {
      if (!DESKTOP.matches || e.pointerType !== 'mouse') return;
      this.cancelClose();
      clearTimeout(this.openTimer);
      if (!item.querySelector('[data-hh-panel]')) {
        if (this.openItem) this.scheduleClose(120);
        return;
      }
      var delay = this.openItem ? 70 : 90;
      this.openTimer = setTimeout(this.openPanel.bind(this, item, false), delay);
    }

    onBarLeave(e) {
      clearTimeout(this.openTimer);
      if (!DESKTOP.matches || e.pointerType !== 'mouse') return;
      this.scheduleClose(220);
    }

    scheduleClose(ms) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(this.closePanel.bind(this), ms);
    }

    cancelClose() {
      clearTimeout(this.closeTimer);
    }

    onTrigger(item, e) {
      e.preventDefault();
      if (DESKTOP.matches) {
        var justOpened = this.openItem === item && Date.now() - this.openedAt < 450;
        if (this.openItem === item && !justOpened) this.closePanel();
        else if (this.openItem !== item) this.openPanel(item, true);
        return;
      }
      this.toggleAccordion(item);
    }

    openPanel(item, fromClick) {
      if (this.openItem === item) return;
      var previous = this.openItem;
      if (previous) this.setItem(previous, false);
      this.openItem = item;
      this.openedAt = fromClick ? 0 : Date.now();
      this.setItem(item, true);
      this.measure();
      this.syncOpen();
      if (this.panelObserver) this.panelObserver.disconnect();
      if (window.ResizeObserver) {
        this.panelObserver = new ResizeObserver(this.measure.bind(this));
        this.panelObserver.observe(item.querySelector('.halo-menu__panel-inner'));
      }
    }

    closePanel() {
      clearTimeout(this.openTimer);
      if (!this.openItem) return;
      this.setItem(this.openItem, false);
      this.openItem = null;
      if (this.panelObserver) this.panelObserver.disconnect();
      this.style.setProperty('--hh-drop', '0px');
      this.syncOpen();
    }

    measure() {
      if (!this.openItem || !DESKTOP.matches) return;
      var inner = this.openItem.querySelector('.halo-menu__panel-inner');
      if (inner) this.style.setProperty('--hh-drop', inner.offsetHeight + 'px');
    }

    setItem(item, open) {
      item.classList.toggle('is-open', open);
      var trigger = item.querySelector('[data-hh-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    /* Celular: menu e sanfona */
    onToggle() {
      if (this.mobileOpen) this.closeMobile(true);
      else this.openMobile();
    }

    openMobile() {
      if (this.mobileOpen) return;
      this.mobileOpen = true;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.labelClose || '');
      document.documentElement.classList.add('halo-header-travado');
      if (this.hasAttribute('data-mobile-first-open') && !this.items.some(function (i) { return i.classList.contains('is-open'); })) {
        var first = this.items.find(function (i) { return i.querySelector('[data-hh-panel]'); });
        if (first) this.setItem(first, true);
      }
      this.menu.scrollTop = 0;
      this.syncOpen();
    }

    closeMobile(focusToggle) {
      if (!this.mobileOpen) return;
      this.mobileOpen = false;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.labelOpen || '');
      document.documentElement.classList.remove('halo-header-travado');
      this.syncOpen();
      var items = this.items;
      var self = this;
      setTimeout(function () {
        if (self.mobileOpen) return;
        items.forEach(function (i) { self.setItem(i, false); });
      }, 450);
      if (focusToggle) this.toggle.focus({ preventScroll: true });
    }

    toggleAccordion(item) {
      var open = !item.classList.contains('is-open');
      this.items.forEach(function (i) {
        if (i !== item) this.setItem(i, false);
      }, this);
      this.setItem(item, open);
    }

    closeAll() {
      this.closePanel();
      if (this.mobileOpen) this.closeMobile(false);
    }

    /* Teclado, foco e cliques */
    onKey(e) {
      if (e.key === 'Escape' && this.isOpen()) {
        var item = this.openItem;
        var wasMobile = this.mobileOpen;
        this.closeAll();
        if (wasMobile) this.toggle.focus({ preventScroll: true });
        else if (item) {
          var trigger = item.querySelector('[data-hh-trigger]');
          if (trigger) trigger.focus({ preventScroll: true });
        }
        return;
      }
      if (e.key === 'Tab' && this.mobileOpen) this.trapFocus(e);
    }

    trapFocus(e) {
      var focusables = Array.from(
        this.bar.querySelectorAll('a[href], button, [role="button"][tabindex]')
      ).filter(function (el) {
        return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    onFocusOut(e) {
      if (!DESKTOP.matches || !this.openItem) return;
      var next = e.relatedTarget;
      if (next && this.bar.contains(next)) return;
      if (next) this.closePanel();
    }

    onOutside(e) {
      if (!this.isOpen() || this.bar.contains(e.target)) return;
      if (this.scrim && e.target === this.scrim) return;
      this.closeAll();
    }

    onBarClick(e) {
      // Links, carrinho e busca fecham o menu antes de seguir (o modal do tema abre por cima).
      var target = e.target.closest('a[href], xo-modal-trigger');
      if (!target || !this.isOpen()) return;
      if (this.mobileOpen) this.closeMobile(false);
      else this.closePanel();
    }

    onTouchMove(e) {
      if (!this.mobileOpen) return;
      if (this.menu.contains(e.target) && this.menu.scrollHeight > this.menu.clientHeight) return;
      if (e.cancelable) e.preventDefault();
    }

    /* Editor: selecionar um item no personalizador abre o painel dele */
    onBlockSelect(e) {
      var target = e.target;
      if (!this.contains(target)) return;
      var item = target.closest('[data-hh-item]');
      if (!item) return;
      if (DESKTOP.matches) {
        if (item.querySelector('[data-hh-panel]')) this.openPanel(item, true);
        else this.closePanel();
      } else {
        this.openMobile();
        if (item.querySelector('[data-hh-panel]') && !item.classList.contains('is-open')) this.toggleAccordion(item);
      }
    }

    /* Contador do carrinho: some quando está vazio */
    watchBadge() {
      var badge = this.querySelector('[data-hh-badge]');
      var count = badge && badge.querySelector('xo-cart-size');
      if (!count) return;
      var sync = function () {
        var n = parseInt(count.textContent, 10);
        badge.hidden = !(n > 0);
      };
      this.badgeObserver = new MutationObserver(sync);
      this.badgeObserver.observe(count, { childList: true, characterData: true, subtree: true });
      sync();
    }
  }

  customElements.define('halo-header', HaloHeader);
})();
